import {
  DefinitionTarget,
  ICustomer,
  ILocationSimple,
  IProduct,
} from '../shared-entities';

export interface IDefinition {
  id: string;
  type: string;
  value: string;
  entityId: string;
  parentId: string;
  isSelectable: boolean;
  targets: DefinitionTarget;
  children: IDefinitionChild[];
  linkId?: string;
}

export interface IDefinitionUpdateResponse {
  id: string;
  name: string;
  targets: DefinitionTarget;
}

export interface IDefinitionSingleDefinitionTargetResponse {
  definitions: IDefinition[];
  target: string;
}

export interface IDefinitionChild {
  id: string;
  type: string;
  value: string;
  isSelectable: boolean;
  targets: DefinitionTarget;
  linkId?: string;
}

export interface IDefinitionsDataResponse {
  customers: ICustomer[];
  products: IProduct[];
  locations: ILocationSimple[];
  users?: any[];
}

export interface IDefinitionsFilterResponse {
  query: string;
  products: any[];
  definitions: any[];
  users: any[];
  locations: any[];
  customers: ICustomer[];
  departments: any[];
  categories: any[];
  brands: any[];
  definitionsFilters: {
    targets: number;
    definitionIds: string[];
    customerIds?: string[];
    locationIds?: string[];
    productIds?: string[];
  };
}
